import BaseApi from "../../../services/Api";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import React, {useEffect, useState} from "react";
import Tooltip from "../../Popups/Tooltip";
import {Modal, Spinner} from "react-bootstrap";
import Button from "../../Layout/Button";
import style from "./style.module.css"

const INITIAL_DATA = {
  total: 0,
  current_page: 1,
  last_page: 1,
  first_page_url: "",
  last_page_url: "",
  next_page_url: "",
  prev_page_url: null,
  path: "",
  from: 1,
  to: 1,
  data: [],
};

const ModalAnimal = ({
                       idAnimal, onUpdate, onCreate, children
                     }) => {
  const [isLoading, setLoading] = React.useState(true);
  const [isSaving, setSaving] = React.useState(true);
  const [isShow, setShowModal] = React.useState(false);

  const [isFiltering, setFiltering] = React.useState(true);
  const [isPaginating, setPaginating] = React.useState(true);

  const [isPinned, setIsPinned] = useState(false);
  const [name, setName] = useState('');
  const [species, setSpecies] = useState('');
  const [description, setDescription] = useState('');
  const [wasAdopted, setWasAdopted] = useState(false);
  const [familyImage, setFamilyImage] = useState(null);
  const [animal_img, setAnimalImage] = useState(null);
  const [updateImage, setUpdateImage] = useState(null);
  const [updateFamilyImage, setUpdateFamilyImage] = useState(null);
  const [sex, setSex] = useState('');
  const [isCastrated, setIsCastrated] = useState(false);
  const [breed, setBreed] = useState('');
  const [birthday, setBirthday] = useState(null);
  const [size, setSize] = useState('');
  const [animalApi, setAnimalApi] = useState({...INITIAL_DATA});
  const [special_animal, setSpecialAnimal] = useState(false);

  const [currentImage, setCurrentImage] = useState(null);
  const [currentFamilyImage, setCurrentFamilyImage] = useState(null);

  const getAnimals = () => {
    BaseApi
        .get("/animais_fixados")
        .then((response) => {
          setAnimalApi(response.data);
        })
        .catch((err) => {
          if (err) {
            console.log(err);
            toast.error("Erro ao carregar dados dos animais");
            setAnimalApi({ ...INITIAL_DATA });
            setLoading(false);
            setPaginating(false);
            setFiltering(false);
          }
        });
  }

  const buildFormData = () =>{
    const formData = new FormData();
    if(isPinned!=undefined){

      formData.append("is_pinned", isPinned);
    }
    if(name!=undefined){

      formData.append("name", name);
    }
    if(species!=undefined){

      formData.append("species", species);
    }
    if(description!=undefined){

      formData.append("description", description);
    }
    if(wasAdopted!=undefined){

      formData.append("was_adopted", wasAdopted);
    }
    if(sex!=undefined){

      formData.append("sex", sex);
    }
    if(isCastrated!=undefined){

      formData.append("is_castrated", isCastrated);
    }
    if(breed!=undefined){

      formData.append("breed", breed);
    }
    if(birthday!=undefined){

      formData.append("birthday", birthday);
    }
    if(size!=undefined){

      formData.append("size", size);
    }
    if(special_animal!=undefined){

      formData.append("special_animal", special_animal);
    }

    if(idAnimal) {
      formData.append('_method', 'PUT')
      if (updateImage) {
        formData.append("animal_img", updateImage);}
      if(updateFamilyImage){
        formData.append("family_image", updateFamilyImage);

      }
    } else{
      if (animal_img){
        formData.append("animal_img", animal_img)
      }
      if (familyImage){
        formData.append("family_image", familyImage)
      }

    }
    return formData
  }

  const formData = buildFormData();

  const onSave = () => {
    Swal.fire({
      title: 'Certeza que deseja salvar?',
      text: "Você não conseguirá reverter isso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: "#198754",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitData();
      } else if (
          result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Operação cancelada!',
          showConfirmButton: false,
          timer: 1500
        })
      }
    })
  }

  const submitData = () => {
    setSaving(true);
    if (idAnimal) {
      BaseApi.post(`/animais/${idAnimal}`, formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Animal atualizado com sucesso!');
        onUpdate && onUpdate(res.data);
      }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados salvos com sucesso!',
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          window.location.reload();
          })

      }).catch(err => {
        console.log(err);
        Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || `${err?.response?.data?.message}`, 'error');
        setSaving(false);
      })
    }
    else {
      BaseApi.post('/animais', formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Animal criado com sucesso');
        onCreate && onCreate(res.data);
      }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados salvos com sucesso!',
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          window.location.reload();
        })
      }).catch(err => {
        console.log(err);
        Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || `${err?.response?.data?.message}`, 'error');
        setSaving(false);
      })
    }

  }

  const handleClose = () => {
    setShowModal(false);
  }



  const handleChangeImage = (e) => {
    let field = e.target.name

    const selectedImage = e.target.files[0];
    if (idAnimal){
      if (selectedImage && field === "image_animal")  {
        setUpdateImage(selectedImage);
        setCurrentImage(selectedImage);
      }
      else if (selectedImage && field === "image_family") {
        setUpdateFamilyImage(selectedImage);
        setCurrentFamilyImage(selectedImage);
      }
    }
    else {
      if (selectedImage && field === "image_animal")  {
        setAnimalImage(selectedImage)
        setCurrentImage(selectedImage);
      }
      else if (selectedImage && field === "image_family") {
        setFamilyImage(selectedImage);
        setCurrentFamilyImage(selectedImage);
      }
    }
  };

  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/animais${idAnimal ? `/${idAnimal}` : ''}`).then(res => {
      let data = res.data;
      setIsPinned(data.is_pinned);
      setName(data.name)
      setSpecies(data.species);
      setDescription(data.description);
      setWasAdopted(data.was_adopted);
      setFamilyImage(data.family_image);
      setCurrentFamilyImage(data.family_image);
      setAnimalImage(data.animal_img);
      setCurrentImage(data.animal_img);
      setSex(data.sex);
      setIsCastrated(data.is_castrated);
      setBreed(data.breed);
      setBirthday(data.birthday);
      setSize(data.size);
      setSpecialAnimal(data.special_animal);
      setLoading(false);
      setSaving(false);
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar esta ação ou o animal não foi encontrado.', 'error');
      setShowModal(false);
    })
  }

  useEffect(() => {
    if(isShow) {
      requestData();
      getAnimals();
    } else {
      setIsPinned(false);
      setName('')
      setSpecies('');
      setDescription('');
      setWasAdopted(false);
      setFamilyImage(null);
      setAnimalImage(null);
      setUpdateImage(null);
      setSex('');
      setIsCastrated(false);
      setBreed('');
      setBirthday(null);
      setSize('');
      setSpecialAnimal(false);
      setLoading(true);
      setSaving(true);
    }
  }, [isShow])

  const pinLimit = () => {
    return animalApi <= 2;
  }

  return (
      <>
        {children &&
            React.cloneElement(children, { onClick: (e) => setShowModal(true) })}
        {!children && (
            <Tooltip text={idAnimal ? "Editar animal" : "Criar animal"}>
              <button
                  className={`btn btn-${idAnimal ? "warning" : ""} text-white fa-bold`}
                  onClick={(e) => setShowModal(true)}
              >
                <i className={`bi bi-${idAnimal ? "person-gear" : "plus"}`}></i>
              </button>
            </Tooltip>
        )}
        <Modal
            centered
            scrollable
            onHide={handleClose}
            show={isShow}
            animation={true}
            size="md"
        >
          <Modal.Header closeButton>
            <Modal.Title>{idAnimal ? "Editar" : "Cadastrar"} animal</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex align-items-center justify-content-center">
              {isLoading && (
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
              )}
            </div>
            {!isLoading && (
                <>
                  <div className="row">
                    {( pinLimit() || isPinned == 1) ?
                        <div className="form-group mb-3">
                          <label className={style.required} htmlFor="is_pinned">Está fixado? </label>
                          <select value={isPinned} name="isPinned" id="isPinned" onChange={(e) => setIsPinned(e.target.value)} className="form-select">
                            <option value="" disabled='disabled' selected>Selecione se está fixado ou não</option>
                            <option value={1}>Sim</option>
                            <option value={0}>Não</option>
                          </select>
                        </div>
                        :
                        <div className="form-group mb-3">
                          <label className={style.required} htmlFor="is_pinned">Está fixado? </label>
                          <select value={isPinned} name="isPinned" id="isPinned" onChange={(e) => setIsPinned(e.target.value)} className="form-select">
                            <option value="" disabled='disabled' selected>Selecione se está fixado ou não</option>
                            <option value={0}>Não</option>
                          </select>
                        </div>
                    }
                    <div className="form-group mb-3">
                      <label className={style.required} htmlFor="name">Nome </label>
                      <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Insira o nome"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label htmlFor="species" className={style.required}>Espécie </label>
                      <select value={species} name="species" id="species" onChange={(e) => setSpecies(e.target.value)} className="form-select">
                        <option value="" disabled='disabled' selected>Escolha a espécie do animal</option>
                        <option value="dog">Cachorro</option>
                        <option value="cat">Gato</option>
                      </select>
                    </div>
                    <div className="form-group mb-3">
                      <label htmlFor="description">Descrição </label>
                      <textarea
                          type="text"
                          className="form-control"
                          id="description"
                          placeholder="Insira a descrição do animal"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className={style.required} htmlFor="was_adopted">Foi adotado? </label>
                      <select value={wasAdopted} name="wasAdopted" id="wasAdopted" onChange={(e) => setWasAdopted(e.target.value)} className="form-select">
                        <option value="" disabled='disabled' selected>Selecione se o animal foi adotado ou não</option>
                        <option value={1}>Sim</option>
                        <option value={0}>Não</option>
                      </select>
                    </div>
                    <div className="form-group mb-3">
                      <label htmlFor="sex" className={style.required}>Gênero </label>
                      <select value={sex} name="sex" id="sex" onChange={(e) => setSex(e.target.value)} className="form-select">
                        <option value="" disabled='disabled' selected>Escolha a espécie do animal</option>
                        <option value="male">Macho</option>
                        <option value="female">Fêmea</option>
                      </select>
                    </div>
                    <div className="form-group mb-3">
                      <label className={style.required} htmlFor="is_castrated">É castrado? </label>
                      <select value={isCastrated} name="isCastrated" id="isCastrated" onChange={(e) => setIsCastrated(e.target.value)} className="form-select">
                        <option value="" disabled='disabled' selected>Selecione se o animal é castrado ou não</option>
                        <option value={1}>Sim</option>
                        <option value={0}>Não</option>
                      </select>
                    </div>
                    <div className="form-group mb-3">
                      <label className={style.required} htmlFor="special_animal">É especial? </label>
                      <select value={special_animal} name="special_animal" id="special_animal" onChange={(e) => setSpecialAnimal(e.target.value)} className="form-select">
                        <option value="" disabled='disabled' selected>Selecione se o animal é especial ou não</option>
                        <option value={1}>Sim</option>
                        <option value={0}>Não</option>
                      </select>
                    </div>
                    <div className="form-group mb-3">
                      <label className={style.required} htmlFor="breed">Raça </label>
                      <input
                          type="text"
                          className="form-control"
                          id="breed"
                          placeholder="Raça"
                          value={breed}
                          onChange={(e) => setBreed(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className={style.required} htmlFor="birthday">Aniversário/Data aproximada </label>
                      <input
                          type="date"
                          className="form-control"
                          id="birthday"
                          value={birthday}
                          onChange={(e) => setBirthday(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label htmlFor="size" className={style.required}>Porte </label>
                      <select value={size} name="size" id="size" onChange={(e) => setSize(e.target.value)} className="form-select">
                        <option value="" disabled='disabled' selected>Escolha o porte do animal</option>
                        <option value="small">Pequeno</option>
                        <option value="medium">Médio</option>
                        <option value="large">Grande</option>
                        <option value="undefined">Indefinido</option>
                      </select>
                    </div>
                    {wasAdopted == 1 ?
                        <div className="form-group mb-3">
                          <label htmlFor="family_image">Imagem com a família </label>

                          <input type="file"
                                 id="image_family"
                                 name="image_family"
                                 className="form-control"
                                 accept="image/*"
                                 onChange={handleChangeImage}
                          />

                          {idAnimal ? (
                                  <div className="d-flex justify-content-center align-items-center mt-2">
                                    <img
                                        src={currentFamilyImage instanceof File ? URL.createObjectURL(currentFamilyImage) : currentFamilyImage}
                                        alt="imagem da família"
                                        style={{ minWidth: 250, width: 350, objectFit: 'cover' }}
                                    />
                                  </div>
                              ) :
                              null
                          }

                          {currentFamilyImage && !idAnimal && (
                              <div className="d-flex justify-content-center align-items-center mt-2">
                                {idAnimal ? <img src={currentFamilyImage} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                                    : <img src={URL.createObjectURL(currentFamilyImage)} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                                }
                              </div>
                          )
                          }
                        </div>
                        : null
                    }
                    <div className="form-group mb-3">
                      <label className={style.required} htmlFor="animal_img">Imagem do Animal </label>

                      <input type="file"
                             id="image_animal"
                             name="image_animal"
                             className="form-control"
                             accept="image/*"
                             onChange={handleChangeImage}
                      />

                      {idAnimal ? (
                              <div className="d-flex justify-content-center align-items-center mt-2">
                                <img
                                    src={currentImage instanceof File ? URL.createObjectURL(currentImage) : currentImage}
                                    alt="animal_img"
                                    style={{ minWidth: 250, width: 350, objectFit: 'cover' }}
                                />
                              </div>
                          ) :
                          null
                      }

                      {currentImage && !idAnimal && (
                          <div className="d-flex justify-content-center align-items-center mt-2">
                            {idAnimal ? <img src={currentImage} alt="currentImage" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                                : <img src={URL.createObjectURL(currentImage)} alt="currentImage" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                            }
                          </div>
                      )
                      }
                    </div>

                  </div>
                </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex align-items-center w-100">
              <div className="d-block me-auto"></div>
              <div className="d-block ms-auto">
                <button
                    className="btn btn-danger text-white me-2"
                    onClick={handleClose}
                >
                  Close
                </button>
                <Button
                    loading={isSaving}
                    onClick={onSave}
                    className="btn btn-success text-white"
                >
                  {idAnimal ? "Editar" : "Criar"}
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </>
  );
}

export default ModalAnimal;